import { render, staticRenderFns } from "./AuthorizationRuleForm.vue?vue&type=template&id=9442ae22&"
import script from "./AuthorizationRuleForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizationRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationRuleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports